<template>
  <div>
    <div class="w-full">
      <div class="md:flex text-center md:justify-between">
        <div
          class="text-custom text-xl lg:text-2xl mb-5 md:mb-0 leading-none font-medium"
        >
          Signal History
        </div>
        <router-link
          class="btn ml-auto py-1 px-5 text-white font-medium hover:text-black"
          to="/admin/signal/new"
          >New Signal</router-link
        >
      </div>

      <!-- component -->
      <div class="py-8">
        <div class="shadow overflow-y-hidden rounded-lg">
          <table class="w-full">
            <thead class="bg-custom text-white">
              <tr>
                <th>No</th>
                <!-- <th>Signal-Id</th> -->
                <th>Title</th>
                <th>Signal</th>
                <th>Status</th>
                <th>Medium</th>
                <th>Audience</th>
                <th>Stats</th>
              </tr>
            </thead>
            <tbody class="text-white" style="background: rgba(64, 64, 64, 0.8)">
              <tr v-for="(key, index) in Object.keys(signals)" v-bind:key="key">
                <td>{{ index + 1 }}</td>
                <!-- <td class="text-left py-3 px-4">{{ signals[key].signalId }}</td> -->
                <td class="text-left py-3 px-4">
                  {{ signals[key].title }}
                </td>
                <td class="text-left py-3 px-4">
                  <p>
                    {{ signals[key].body }}
                  </p>
                </td>
                <td class="text-left py-3 px-4">{{ signals[key].status }}</td>
                <td class="text-left py-3 px-4">{{ signals[key].medium }}</td>
                <td class="text-left py-3 px-4">
                  {{
                    signals[key].audienceType == "all"
                      ? "All Users"
                      : (signals[key].audiences || []).join(",")
                  }}
                </td>
                <td class="text-left py-3 px-4">
                  <pre v-if="signals[key].stats">Total: {{ signals[key].stats.total }} <br/>Success: {{ signals[key].stats.success }} <br/>Failure: {{ signals[key].stats.failed }}
                  </pre>
                </td>
              </tr>

              <tr>
                <td></td>
                <td class="text-left py-3 px-4">&nbsp;</td>
                <td class="text-left py-3 px-4"></td>
                <td class="text-left py-3 px-4"></td>
                <td class="text-left py-3 px-4"></td>
                <td class="text-left py-3 px-4"></td>
                <td class="text-left py-3 px-4"></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import Layout from "@/views/admin/Layout.vue";
import firebase from "firebase";
import moment from "moment";

export default {
  name: "Signals",
  metaInfo: {
    title: "Spyows",
    titleTemplate: "%s | Signals",
    htmlAttrs: {
      lang: "en",
      amp: true
    }
  },
  /* components: {
    Layout
  }, */
  data() {
    return {
      moment: moment,
      userData: null,
      signals: {}
    };
  },
  mounted() {
    let user = firebase.auth().currentUser;
    firebase
      .database()
      .ref(`users/${user.uid}`)
      .on("value", snapshot => {
        this.userData = snapshot.val();
      });
    let ref = firebase
      .database()
      .ref("signals")
      .orderByChild("createdAt");
    if (ref && ref.on) {
      ref.on("value", data => {
        this.signals = data.val() || {};
      });
    }
  }
};
</script>

<style lang="postcss" scoped>
table thead tr th {
  @apply text-left py-5 px-4 uppercase font-semibold text-sm;
}
table tbody tr {
  @apply border-b border-gray-300;
}
table tbody tr td {
  @apply text-left py-3 px-4 border-r border-gray-300;
}
table tbody tr td:last-child,
table tbody tr:last-child {
  @apply border-none;
}
</style>
